import { DATASTRATEGY, IEntity } from '@proximus/entity-manager';
import { SessionStorageStrategy } from '@proximus/entity-manager/lib/storage/strategies/session-storage.strategy';
import { INspStatistics } from '../utils/nsp.utils';

export const NspProductsInPackEntity: IEntity<any> = {
  url: '/rest/products-detail-aggregator/networksecuritypack/{packId}/details',
  requestHeaders: [],
  rel: 'pda:networksecuritypack',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const NspStandaloneProductsEntity: IEntity<any> = {
  url: '/rest/products-detail-aggregator/networksecurityproduct/details{?plc,productId}',
  requestHeaders: [],
  rel: 'pda:networksecurityproduct',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};

export const NspStatisticProductsEntity: IEntity<INspStatistics> = {
  url: '/rest/products-detail-aggregator/networksecurityproduct/statistics',
  version: 'v1',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};
